import { render } from "./question-box.vue?vue&type=template&id=31d1fb66&scoped=true"
import script from "./question-box.vue?vue&type=script&lang=js"
export * from "./question-box.vue?vue&type=script&lang=js"

import "./question-box.vue?vue&type=style&index=0&id=31d1fb66&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d1fb66"]])

export default __exports__